import { useState } from 'react';
import { data, useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import * as Setting from '../../utils/AuthUtils'
import ImportTournamentResults from './ImportTournamentResults';
import { api } from '../../AppConfig';

function RoutedImportTournamentResults(props) {
  // Access the client
  const queryClient = useQueryClient();

  const { id } = useParams();
  const { hasRights } = props;
  const [previewResults, setPreviewResults] = useState([]);
  const [loading, setLoading] = useState(null);
  const [successfulImport, setSuccessfulImport] = useState(false);
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const tournamentQuery = useQuery({ 
    queryKey: [`tournament${id}`], 
    queryFn: () => 
      fetch(api.tournaments().detailsById(id).href, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        }})
        .then((res) =>
        res.json(), 
      )
  })

  const playerQuery = useQuery({ 
    queryKey: [`players`], 
    queryFn: () => 
      fetch(api.players().list().href).then((res) =>
        res.json(), 
      )
  })

  const platformQuery = useQuery({
    queryKey: [`platforms`], 
    queryFn: () => 
      fetch(api.platforms().list().href).then((res) =>
        res.json(), 
      )
  })

  const importFileQuery = useMutation({
    mutationFn: async (p) => {
      setLoading(true);
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      const formData = new FormData();
      formData.append('uploadedFile', p.file);
      formData.append('platform', p.platform);
      const response = await fetch(api.tournaments().importResults(p.tournamentId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
        },
        body: formData,
      })
      .then(async (res) => {
        if (res.status != 200) {
          var returnData = await res.json();
          // console.warn('return response:', returnData);
          throw new Error(`An error occurred! Cause: ${returnData.errorMsg}`);
        }
        return res.json();
      })
      return response;
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      // Invalidate and refetch
      message.success('Results successfully imported!');
      setPreviewResults(data.payLoad || []);
      setLoading(false);
      // window.location.reload(false)
    },
    onSettled: (data, variables, onMutateResult, context) => {
      // Invalidate and refetch
      // message.success('Results successfully imported!');
      // console.warn('stato di data: ', data);
      // console.warn('staot di variables: ', variables);
      // console.warn('stato di onMutateResult: ', onMutateResult);
      // console.warn('stato di context: ', context);
      // window.location.reload(false)
    },
    onError: (error, data) => {
      // console.warn('data arrivati dopo onError:', data, error)
      setPreviewResults([]);
      message.error(`Operation failed! ${error}`, 10);
      setLoading(false);
    },
  })

  const addPlayerQuery = useMutation({
    mutationFn: async (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      let response = await fetch(api.tournaments().addPlayer(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })
      .catch((error) => {
        console.log(error);
        throw new Error('An error occurred');
      })
      if (response.status === 403) throw new Error('Forbidden!');
    },
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Successfully added player to event!');
      window.location.reload(false)
    },
    onError: () => {
      // console.warn('data arrivati dopo onError:', data, error, variables,context)
      message.error('Operation failed! Probably you do not have permission to do this.');
    },
    onSettled: (data, error) => {
      if (error === null) {
        // console.warn('non ho avuto errori!');
        queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
        queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      }
    },
  })

  const deletePlayerQuery = useMutation({
      mutationFn: (p) => {
        // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
        fetch(api.tournaments().removePlayer(p.tournamentId).href, {
          method: 'DELETE',
          headers: {
            'Authorization': 'Bearer ' + Setting.getToken(),
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(p),
        })},
      onSuccess: async () => {
        // Invalidate and refetch
        message.success('Player successfully removed!');
        // window.location.reload(false)
      },
      onSettled: async () => {
        await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
        await queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      }
  })

  const saveImportedResultsQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.tournaments().importStore(p.tournamentId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p.results),
      })},
    onSuccess: async () => {
      // Invalidate and refetch
      message.success('Ranking successfully updated!');
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      // now we redirect to tournament page
      // window.location.href = '/tournaments/' + p.tournamentId;
      setSuccessfulImport(true);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      // window.location.reload(false)
    },
  })

  if (!id) return (<div></div>);
  
  return <ImportTournamentResults 
          id={id} 
          loading={loading}
          importResults={importFileQuery}
          previewResults={previewResults}
          saveImportedResults={saveImportedResultsQuery}
          successfulImportFlag={successfulImport}
          platforms={platformQuery}
          players={playerQuery}
          tournament={tournamentQuery} 
          addPlayer={addPlayerQuery}
          deletePlayer={deletePlayerQuery}
          hasRights={hasRights}
          />;
}

export default RoutedImportTournamentResults;